var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.node.title)?_c('strong',[_vm._v(_vm._s(_vm.node.name))]):_vm._e(),(_vm.node.url)?_c('p',[_c('a',{attrs:{"href":_vm.node.text,"target":"_blank"}},[_vm._v(_vm._s(_vm.node.text))])]):_c('p',{class:{
      collapsible: _vm.node.collapsible,
      'collapsible-collapsed': _vm.node.collapsible && _vm.node.collapsed
    },domProps:{"innerHTML":_vm._s(_vm.docText)},on:{"click":function($event){_vm.node.collapsed = !_vm.node.collapsed}}})])}
var staticRenderFns = []

export { render, staticRenderFns }